import { useMutation } from "react-query";
import { ILoginData } from "types/Login";
import { postRegisterGuest } from "../requests/RegisterGuest";
import logger from "components/Logger"
export function useMutationRegisterGuest() {

    const query = useMutation(postRegisterGuest, {
        onSuccess: (data) => {
            logger.log('useMutationRegisterGuest success:')
            if(data?.success) {
                let loginInfo: ILoginData = data?.data;
                localStorage.setItem('idGuest', JSON.stringify(loginInfo.id))
            } else {
                // console.log(data?.errors)
            }
        }, onError: (data) => {
            logger.log('useMutationRegisterGuest DEU ERRO! ***********')
            // console.error(data)
        }
    });

    return query;
}
